import type { CategoryContent } from '../row.js';

export const MATERIALS_SCIENCE: CategoryContent = {
  bscba: [
    [
      'Welke term beschrijft de regelmatige, zich herhalende 3D-rangschikking van atomen in een kristallijn materiaal?',
      [
        'Kristalrooster',
        'Amorf structuur',
        'Korrelgrens',
        'Eenheidscel',
      ],
      0,
      'Een kristalrooster is het zich herhalende patroon van atomen; \'eenheidscel\' verwijst naar de kleinste zich herhalende eenheid erin.',
    ],
    [
      'Welke van deze is een primaire maatstaf voor de weerstand van een materiaal tegen permanente vervorming onder belasting?',
      [
        'Vloeispanning',
        'Thermische geleiding',
        'Brekingsindex',
        'Permeabiliteit',
      ],
      0,
      'Vloeispanning markeert de spanningsgrens waarboven een materiaal permanent vervormt. Andere eigenschappen meten ander gedrag.',
    ],
    [
      'Welke as van een fasediagram stelt typisch samenstelling in een binair legeringssysteem voor?',
      [
        'Horizontale as',
        'Verticaal (y-as)',
        'Diagonaal',
        'Radiaal',
      ],
      0,
      'Fasediagrammen gebruiken de horizontale as voor samenstelling en de verticale as voor temperatuur in standaard binaire systemen.',
    ],
    [
      'Welke materiaalklasse wordt gedefinieerd door lange-ketenorganische moleculen met herhalende eenheden?',
      [
        'Polymeren',
        'Keramiek',
        'Metalen',
        'Composieten',
      ],
      0,
      'Polymeren bestaan uit monomeren die in lange ketens zijn verbonden. Keramiek bestaat uit anorganische verbindingen, metalen zijn elementair/gelegeerd, composieten combineren matrix en versterking.',
    ],
    [
      'Wat is het primaire bindingsmechanisme in keramische materialen?',
      [
        'Ionisch en covalent',
        'Metallische binding',
        'Waterstofbinding',
        'Van der Waalskrachten',
      ],
      0,
      'Keramiek is afhankelijk van ionische en covalente bindingen tussen atomen. Metalen gebruiken metallische binding; polymeren gebruiken covalente ruggengraat met zwakkere secundaire krachten.',
    ],
    [
      'In metallurgie, wat is een legering?',
      [
        'Een mengsel met minstens één metaal',
        'Een zuiver metaalelement',
        'Een chemische verbinding met vaste stoichiometrie',
        'Een gelaagde structuur van verschillende metalen',
      ],
      0,
      'Een legering is een metallische mengsel (vaste oplossing, intermetallisch of multifase) ontworpen om eigenschappen te verbeteren ten opzichte van het basismetaal.',
    ],
    [
      'Welke mechanische eigenschap beschrijft het vermogen van een materiaal om energie op te nemen voordat het breekt?',
      [
        'Taaiheid',
        'Hardheid',
        'Stijfheid',
        'Ductiliteit',
      ],
      0,
      'Taaiheid combineert sterkte en ductiliteit en meet opgenomen energie tijdens breuk. Hardheid weerstaat indrukking; stijfheid weerstaat vervorming; ductiliteit is permanente vervormingscapaciteit.',
    ],
    [
      'Welke techniek meet de weerstand van een materiaaloppervlak tegen krassen of indrukking?',
      [
        'Hardheidstest',
        'Trektest',
        'Thermische analyse',
        'Röntgendiffractie',
      ],
      0,
      'Hardheidstests (Vickers, Rockwell, Brinell) kwantificeren oppervlakteweerstand. Trektesting meet sterkte/ductiliteit; thermische analyse volgt faseveranderingen; röntgendiffractie identificeert kristalstructuur.',
    ],
    [
      'Welke van deze is een primaire toepassing voor halfgeleiders in materiaalkunde?',
      [
        'Geleidbaarheid beheersen',
        'Dragende structuurcomponenten',
        'Het verbeteren van polymeersterkte',
        'Het verhogen van keramische taaiheid',
      ],
      0,
      'Halfgeleiders (Si, Ge, GaAs) zijn ontworpen voor gecontroleerde elektrische eigenschappen. De andere opties beschrijven verschillende materiaalfuncties.',
    ],
    [
      'Wat is een composietmateriaal?',
      [
        'Twee of meer materialen gecombineerd',
        'Een enkel zuiver element met meerdere kristallijne fasen',
        'Een legering met precies drie componenten',
        'Een polymeer versterkt met alleen inerte vullers',
      ],
      0,
      'Composieten combineren opzettelijk matrix en versterking (vezels, deeltjes, enz.) om de sterktes van elk onderdeel te benutten.',
    ],
    [
      'In de materiaalkunde, waar verwijst de term \'korrel\' naar?',
      [
        'Een enkel kristaldomein',
        'Een standaard voor classificatie van deeltjesgrootte',
        'De textuur van een polymeeroppervlak',
        'Een defect in een keramische structuur',
      ],
      0,
      'Een korrel is één kristallijn domein; korrels worden gescheiden door korrelgrenzen. Korrelgrootte beïnvloedt materiaaleigenschappen dramatisch.',
    ],
    [
      'Welke van deze stelt de hoogste pakketdichtheid voor bollen in een rooster voor?',
      [
        'FCC of HCP',
        'Eenvoudige kubisch',
        'Kubisch lichaamsgecentreerd',
        'Diamantkubisch',
      ],
      0,
      'FCC en HCP bereiken beide ~74% pakketdichtheid. Eenvoudige kubisch is ~52%, BCC is ~68%, diamantkubisch is ~34%.',
    ],
    [
      'Wat bereikt \'gloeien\' in metaalbewerking?',
      [
        'Verhitten en langzaam afkoelen',
        'Snel afkoelen om hardheid te verhogen',
        'Legeren met koolstof om staal te versterken',
        'Het oppervlak polijsten om het uiterlijk te verbeteren',
      ],
      0,
      'Gloeien verlicht spanning, kristalliseert de structuur opnieuw en verzacht het metaal. Snel afkoelen (blussen) verhardde; legeren voegt sterkte toe; polijsten is cosmetisch.',
    ],
    [
      'Welke eigenschap beschrijft de neiging van een materiaal om energie op te nemen en vervolgens vrij te geven wanneer het elastisch wordt vervormd?',
      [
        'Veerkracht',
        'Breekbaarheid',
        'Kneedbaarheid',
        'Transparantie',
      ],
      0,
      'Veerkracht is het elastische energieopnamecapaciteit. Breekbaarheid betekent beperkte plastische vervorming voor breuk; kneedbaarheid is vormveranderingsvermogen; transparantie is lichtdoorlaatbaarheid.',
    ],
    [
      'Welke structuurkenmerk maakt polymeren flexibel in vergelijking met metalen?',
      [
        'Zwakke secundaire bindingen',
        'Lagere atoommassa',
        'Lagere smelttemperaturen',
        'Willekeurige atoomarrangementen',
      ],
      0,
      'Polymeerketens worden bijeengehouden door zwakke secundaire krachten, waardoor kettingbeweging mogelijk is. Metalen hebben stijve metallische binding door de hele structuur.',
    ],
  ],
  msc: [
    [
      'Wat is de betekenis van het eutectisch punt op een binair fasediagram?',
      [
        'De samenstelling met de laagste smelttemperatuur',
        'Het punt van maximale oplosbaarheid van het ene metaal in het ander',
        'De samenstelling waar mechanische eigenschappen optimaal zijn',
        'De kritieke temperatuur waarboven het systeem een enkele fase wordt',
      ],
      0,
      'Het eutectisch punt is de samenstelling met de laagste smelttemperatuur; alle samenstellende stoffen kristalliseren tegelijk bij constante temperatuur, met karakteristieke lamellaire microstructuur.',
    ],
    [
      'In polymeerwetenschap, welke term beschrijft de mate waarin polymeerketens in geordende, regelmatige arrays zijn gerangschikt?',
      [
        'Kristalliniteit',
        'Polymerisatie',
        'Vertakking',
        'Vervetting',
      ],
      0,
      'Kristalliniteit meet geordende tegen amorfe kettingverpakking; hoge kristalliniteit verhoogt sterkte en smeltpunt. Polymerisatie is kettinggroei; vertakking en vervetting veranderen topologie.',
    ],
    [
      'Welke keramische fabricagetechniek omvat het oplossen van voorloperingsmaterialen en het vormen van een gel die wordt gedroogd en gesinterd?',
      [
        'Sol-gelsynthese',
        'Droog persen',
        'Gietwerkprocédé',
        'Heet persen',
      ],
      0,
      'Sol-gel produceert fijne, homogene keramiek bij lage temperaturen via voorloperingsgelatie. Persen en gieten gebruiken voorgevormde poeders; heet persen combineert druk en warmte.',
    ],
    [
      'Welk mechanisme stelt martensitische transformatie in staal in staat om hardheid te produceren?',
      [
        'Diffusieloze atoomherrangschikking',
        'Nucleatie en groei van cementiedeltjes',
        'Korrelvereffening door snelle afkoeling',
        'Neerslag van intermetallische fasen',
      ],
      0,
      'Martensiet vormt via een diffusieloze (athermale) schuiftransformatie, waarbij koolstofatomen worden opgesloten en stijve, harde kristalstructuur wordt gecreëerd.',
    ],
    [
      'In breukmechanica, wat kenmerkt de spanningsintensiteitsfactor (K)?',
      [
        'De ernst van het scheurtipveld',
        'De totale sterkte van het materiaal',
        'De ductiliteit van het materiaal',
        'De temperatuur waarop breuk optreedt',
      ],
      0,
      'K kwantificeert scheurtipspanningsconcentratie; breuk treedt op wanneer K de kritieke breuksoepelheid (K_IC) overschrijdt. Het verbindt materiaaleigenschappen met defectgrootte en spanning.',
    ],
    [
      'Wat is het primaire voordeel van het toevoegen van versterkingsvezels aan een polymeermatrix in composieten?',
      [
        'Vezels geven stijfheid, matrix geeft taaiheid',
        'Vezels verminderen de totale dichtheid van de composiet',
        'Vezels voorkomen dat de matrix kristalliseert',
        'Vezels vergroten de transparantie van het materiaal',
      ],
      0,
      'Met vezels versterkte composieten combineren de sterkte en stijfheid van de vezels met de ductiliteit van de matrix, wat superieure specifieke (gewichtsgerekende) eigenschappen oplevert.',
    ],
    [
      'Welke karakteriseringstechniek gebruikt een röntgenstraalbundel die door kristalvlakken wordt afgebogen om fasen en roosterparameters te identificeren?',
      [
        'Röntgendiffractie (XRD)',
        'Differentiaalscanningcalorimetrie (DSC)',
        'Transmissie-elektronenmicroscopie (TEM)',
        'Atoomkrachtmicroscopie (AFM)',
      ],
      0,
      'XRD past de wet van Bragg toe op kristalvlakken en produceert diffractiepatronen die fasen identificeren en roosterconstanten kwantificeren. DSC meet thermische gebeurtenissen; TEM en AFM leggen structuur in beeld.',
    ],
    [
      'Wat is het Hall-effect in halfgeleiders en waarom is het significant?',
      [
        'Een transversale spanning door stroom in een magneetveld',
        'De verandering in bandgapenergie bij aangelegde spanning',
        'De opwekking van licht wanneer stroom door een junctie vloeit',
        'De weerstandsverandering bij zeer lage temperaturen',
      ],
      0,
      'Hall-effect (transversale spanning van stroom × magnetisch veld) meet laaddragersdichtheid en -type. Het is cruciaal voor karakterisering van halfgeleiderdoping en mobiliteit.',
    ],
    [
      'In legeringsontwerp, wat is een vaste-oplossingsversterkingsmechanisme?',
      [
        'Soluteatomen die het rooster vervormen',
        'Neerslag van een tweede fase aan korrelgrenzen',
        'Vorming van nieuwe kristallijne fasen met verschillende structuren',
        'Vermindering van korrelgrootte door korrelgrenzen vast te zetten',
      ],
      0,
      'Soluteatomen creëren lokale roostervervormingen die dislocatieslip blokkeren, wat vloeispanning verhoogt zonder aparte deeltjes toe te voegen.',
    ],
    [
      'Welke eigenschap van een polymeer wordt gemeten door trektesting met veel lagere snelheid dan normaal om tijdsafhankelijk gedrag aan het licht te brengen?',
      [
        'Kruipgedrag',
        'Slagsterkte',
        'Scheurweerstand',
        'Oppervlaktehardheid',
      ],
      0,
      'Kruiptesting past constante spanning toe bij lage vervormingssnelheid om permanente vervorming over tijd te kwantificeren—kritiek voor polymeren met langdurige belasting.',
    ],
    [
      'Welke nanomateriaalvorm bestaat uit éénatomdikke koolstofplaten in een zeshoekig rooster?',
      [
        'Grafeen',
        'Koolstofnanobuizen',
        'Fullerenen',
        'Nanodeeltjes',
      ],
      0,
      'Grafeen is een 2D-allotropie met uitzonderlijke sterkte, geleiding en stijfheid. Nanobuizen zijn 1D opgerolde grafeen; fullerenen zijn 0D kooimoleculen; nanodeeltjes zijn massieve bollen.',
    ],
    [
      'Wat is de rol van een dislocatie in plastische vervorming van kristallijne materialen?',
      [
        'Een lijndefect dat door het rooster beweegt',
        'Een puntdefect veroorzaakt door ontbrekende atomen op roosterlokaties',
        'Een korrelgrens die twee kristaloriëntaties scheidt',
        'Een stapelfout in een gelaagde structuur',
      ],
      0,
      'Dislocaties (lijndefecten) bewegen door afschuiving, wat plastische stroming mogelijk maakt bij spanningen veel onder theoretische limieten. Andere defecten beïnvloeden gedrag anders.',
    ],
    [
      'In materiaalkunde-karakterisering, welk fenomeen meet differentiaalscanningcalorimetrie (DSC)?',
      [
        'Warmtestroom als de temperatuur verandert',
        'De kristallijne structuur van het monster',
        'De oppervlakteruwheid en topografie',
        'De elektrische geleidbaarheid tegen temperatuur',
      ],
      0,
      'DSC meet warmtestroom (endo/exotherm) om smelting, kristallisatie, glastransities en ontleding op te sporen. XRD onthult structuur; AFM geeft topologie in kaart; andere methoden meten geleidbaarheid.',
    ],
    [
      'Wat is het primaire mechanisme waarmee korrelgrenstechniek de breuksoepelheid in keramiek verbetert?',
      [
        'Gecontroleerde interkristallijne kristallografie',
        'Het totale aantal korrels in het materiaal vergroten',
        'Kleine hoeveelheden ductiele fasen aan grenzen toevoegen',
        'Alle korrelgrenzen elimineren via enkelvoudige kristalgroei',
      ],
      0,
      'Afgestemde korrelgrenzentypen (bijvoorbeeld tweelingkorrelgrenzen van hogere orde) buigen en stompen scheuren af, wat energieabsorptie voor breuk verhoogt.',
    ],
    [
      'Wat is de betekenis van de Schmid-factor in het bepalen van de gemakkelijkheid van dislocatieslip op een bepaald glidsysteem?',
      [
        'De opgeloste afschuifspanning, τ = σ·cos(φ)·cos(λ)',
        'Het meet de totale dislocatiedichtheid in het materiaal',
        'Het beheert de thermische stabiliteit van dislocaties',
        'Het bepaalt de snelheid van dislocatienucleatie',
      ],
      0,
      'Schmid-factor m = cos(φ)cos(λ) voorspelt systeemactivering bij glidding; systemen met hoogste m buigen eerst. Kritieke opgeloste afschuifspanning τ_CRSS is onafhankelijk van σ-grootte.',
    ],
  ],
  phd: [
    [
      'Wat onthult het Gibbs-vrije-energieoppervlak wanneer het wordt uitgezet als functie van samenstelling en temperatuur in een ternair fasediagram?',
      [
        'De thermodynamische stabiliteit van fasen',
        'De mechanische eigenschappen van elke fase als functie van samenstelling',
        'Het kinetische traject waarlangs een fase in een ander transformeert',
        'Het elektrische-geleiding-oppervlak van het legeringssysteem',
      ],
      0,
      'G(X,T)-oppervlakken identificeren stabiele fasen; fasegrenzen ontstaan uit gemeenschappelijke raakpunten. Dit is de thermodynamische basis van fasediagrammen.',
    ],
    [
      'In materiaaldegradatie, wat is de rol van elektrochemisch potentiaal in putcorrosie van gepassiveerde metalen?',
      [
        'De passieve film breekt af boven een kritieke potentiaal',
        'Het potentiaal bepaalt de snelheid van uniforme corrosie over het oppervlak',
        'Het elektrochemische potentiaal beheert de dikte van de oxidlaag',
        'Het bepaalt direct de mechanische sterkte van het gecorrodeerde materiaal',
      ],
      0,
      'Putcorrosie ontstaat wanneer aangelegde of gelokaliseerde potentiaal Eₚᵢₜ overschrijdt, wat de passiverende oxidfilm afbreekt en zelf-voortplantende corrosie triggert.',
    ],
    [
      'Wat is de oorsprong van de glastransitietemperatuur (T_g) in amorfe polymeren, en hoe verschilt het van kristallijn smelten?',
      [
        'T_g is kinetisch, Tₘ is een echte fasewijziging',
        'T_g treedt bij hogere temperaturen op dan Tₘ in alle polymeren',
        'T_g vereist een kristalstructuur om te worden gedefinieerd',
        'Zowel T_g als Tₘ meten dezelfde thermodynamische gebeurtenis',
      ],
      0,
      'T_g is een kinetische overgang (kettingbevriezing/ontdooiing); Tₘ is een ware faseovergang die geordende kristallen smelt. Ze weerspiegelen verschillende fysische fenomenen.',
    ],
    [
      'In halfgeleiderfysica, wat bepaalt de breedte van de depletieregion in een p-n junctie bij thermisch evenwicht?',
      [
        'Ingebouwde potentiaal en doperingsniveaus',
        'De aangelegde externe spanning',
        'De thermische energie van de ladingsdragers',
        'De bandgapenergie van het materiaal',
      ],
      0,
      'Depletiebreedte W ∝ √(V_bi/[eNₐ+eN_D]) uit de Poisson-vergelijking; ingebouwde potentiaal (ln(Nₐ N_D / nᵢ²)) en doperingsniveaus beheersen het.',
    ],
    [
      'Wat is de betekenis van de Burgers-vector in het karakteriseren van dislocaties, en hoe verhoudt het zich tot het dislocatietype?',
      [
        'De grootte en richting van roostervervorming',
        'Het bepaalt de energie die nodig is om de dislocatie te vormen',
        'Het beheert of de dislocatie via klim of glijden kan bewegen',
        'Het meet de afstand die de dislocatie door het kristal heeft bewogen',
      ],
      0,
      'Burgers-vector b kenmerkt het defect; voor rand b ⊥ lijnrichting, voor schroef b ∥ lijnrichting. b-grootte geeft roostervervorming en energie aan.',
    ],
    [
      'In composietmechanica, wat voorspelt de mengselverhoudingsregel, en onder welke belastingconditie is het het nauwkeurigst?',
      [
        'Een gewogen gemiddelde van samenstellingseigenschappen',
        'De breukspanning van de composiet ongeacht belastingsrichting',
        'De thermische expansiecoëfficiënt van alle vezelversterkte composieten',
        'De elektrische geleidbaarheid van keramische matrixcomposieten',
      ],
      0,
      'Mengselverhoudingsregel: E_c = V_f E_f + Vₘ Eₘ is nauwkeurig voor longitudinale belasting waar belastingen rechtstreeks via vezels worden overgedragen.',
    ],
    [
      'Welke mechanismen domineren verbetering van breuksoepelheid in transformatie-verharde zirkonia-keramiek?',
      [
        'Een spanningsgeïnduceerde fasetransformatie',
        'Plastische vervorming van korrelgrenzen',
        'Microscheuring voor de scheurtip',
        'Neerslag van een metallische fase',
      ],
      0,
      'De tetragonale fase van zirkonia is metastabiel; scheurtipspanning triggert transformatie naar monoklien, wat volumeexpansie creëert die scheuren comprimeert en energie dissipeert.',
    ],
    [
      'In nanomaterialen, wat is de rol van de oppervlakte-naar-volume-verhouding in het veranderen van materiaaleigenschappen ten opzichte van de bulk?',
      [
        'Bij kleine afmetingen domineert oppervlakte-energie',
        'Oppervlakte-effecten zijn verwaarloosbaar onder 100 nm',
        'Oppervlakteatomen zijn chemisch identiek aan bulkatomen',
        'Nanomaterialen hebben altijd hogere smeltpunten dan bulk',
      ],
      0,
      'Naarmate de grootte afneemt, neemt S/V toe; oppervlakte-energie wordt dominant, verlaagt Tₘ (Gibbs-Thomson), verhoogt sintering/diffusie, wijzigt thermodynamische stabiliteit.',
    ],
    [
      'Wat is de fysische basis van het Griffith-criterium voor breuk van brosse materialen, en wat voorspelt het?',
      [
        'Vrijgegeven vervormingsenergie is gelijk aan oppervlakte-energie',
        'Breuk wordt zuiver door spanning beheerst en is onafhankelijk van foutgrootte',
        'Alle materialen bezwijken bij dezelfde aangelegde spanning als scheuren aanwezig zijn',
        'Plastische vervorming treedt altijd voor breuk op',
      ],
      0,
      'Griffith: spanning vereist voor breuk σ = √(2Eγ/πa) neemt af met foutgrootte a. Energiebalans (elastische vrijgave versus oppervlaktecreatie) voorspelt instabiliteit.',
    ],
    [
      'In legerings-thermodynamica, wat geeft een negatieve mengingswarmte aan, en hoe beïnvloedt het fasestabiliteit?',
      [
        'Gunstige atoominteracties die menging stabiliseren',
        'Afstotende interacties die altijd fasescheiding veroorzaken',
        'Geen effect op fasestabiliteit of fasediagramvorm',
        'Een indicator dat de legering amorf zal zijn',
      ],
      0,
      'Negatieve ΔHₘᵢₓ bevordert atoominteractie en homogene menging; fasescheiding treedt op bij grotere |ΔS|. Positieve ΔHₘᵢₓ drijft fasesplitsing aan.',
    ],
    [
      'Welke informatie biedt transmissie-elektronenmicroscopie (TEM) die rasterelektronenmicroscopie (SEM) niet kan?',
      [
        'Kristalstructuur en defecten met atoomresolutie',
        'Hogere bedrijfsspanningen voor diepere penetratie',
        'Betere kleurafbeelding van monsteroppervlakken',
        'Snellere analyse van grote monstergebieden',
      ],
      0,
      'TEM stuurt elektronen door dunne monsters, wat atoomstructuur, dislocaties en interfaces onthult (nm–Å resolutie); SEM beeldt oppervlakken topografisch af (nm resolutie).',
    ],
    [
      'In biomaterialen, wat is osseo-integratie, en welke materiaal- en oppervlakteeigenschappen verbeteren deze?',
      [
        'Direct bot-implantaatcontact via bioactieve oppervlakken',
        'Implantaatmaterialen die volledig inert en niet-reactief zijn',
        'Elk metalen implantaat dat lange-termijn stabiliteit in het lichaam bereikt',
        'De inkapseling van een implantaat in littekenweefsel',
      ],
      0,
      'Osseo-integratie vereist bioactieve oppervlakken (TiO₂, hydroxylgroepen, calciumfosfaat) en ruwheid (microschaal) voor osteoblastenhechting en botvorming.',
    ],
    [
      'Wat is de theoretische vloeispanning van een perfect kristal, en hoe vergelijkt werkelijke vloeispanning zich vanwege dislocaties?',
      [
        'De echte vloeispanning is veel lager, door dislocaties',
        'Werkelijke vloeispanning overschrijdt altijd theoretische sterkte',
        'Dislocaties verhogen de spanning die nodig is om het materiaal te vervormen',
        'Perfecte kristallen zijn onmogelijk, dus theorie is irrelevant',
      ],
      0,
      'Perfect kristal: σ_th ≈ G/30 (alle bindingen breken tegelijkertijd). Dislocaties staan afschuiving via herrangschikking toe, wat waargenomen σ_y met 1–2 orden van grootte verlaagt.',
    ],
    [
      'In verwerkings-structuur-eigenschap-relaties, hoe verandert snelle solidificatie de microstructuur en vergroot vaste-oplossingsgrenzen in legeringen?',
      [
        'Het onderdrukt diffusie, wat overtollige solute in de val zet',
        'Snelle afkoeling produceert altijd evenwichtsfasen',
        'Afkoelingssnelheid heeft geen effect op vaste oplosbaarheid',
        'Alleen korrelgrootte wordt beïnvloed; samenstelling blijft evenwicht',
      ],
      0,
      'Snelle solidificatie onderdrukt diffusie kinetisch; soluteatomen worden ingesloten, wat evenwichtsoplosbaarheid overschrijdt en niet-evenwichtige vaste oplossingen en metastabiele fasen vormt.',
    ],
    [
      'Wat is de relatie tussen stapelfoutenergie (SFE) en dislocatietype in FCC-metalen?',
      [
        'Lage SFE bevordert twinning boven kruisglij',
        'SFE bepaalt de glijrichting in BCC-metalen',
        'Hoge SFE leidt altijd tot brosse breuk',
        'SFE is onafhankelijk van legeringssamenstelling',
      ],
      0,
      'Lage SFE (bijv. Cu, Ag legeringen) verbreed partiële dislocatiescheiding, belemmert kruisglij en bevordert twinning; hoge SFE (Al, Ni) bevordert gemakkelijk kruisglij en verharding.',
    ],
  ],
  professor: [
    [
      'In thermodynamische modellering van multicomponent-legeringen, wat is de fysische en wiskundige betekenis van de excess Gibbs-energie (G^ex) in het bepalen van fasestabiliteit en ordening?',
      [
        'Afwijkingen van ideaal mengingsgedrag',
        'G^ex is altijd nul in alle echte materialen',
        'G^ex beïnvloedt alleen de entropieterm, niet enthalpie',
        'G^ex is zuiver empirisch zonder fysische basis',
      ],
      0,
      'G^ex (niet-ideale bijdrage) ontstaat uit atoominteracties; zijn vorm bepaalt fasediagramtopologie—mengbaarheidskloven, consolute-punten en orde-wanorde-overgangen.',
    ],
    [
      'Wat verklaart het Cottrell-atmosfeermodel in ijzerhoudende metallurgie, en hoe verhoudt het zich tot dynamische vervormingsveroudering en het Portevin–Le Chatelier-effect?',
      [
        'Dynamisch vergrendelen en ontgrendelen van soluteatmosferen',
        'Het Cottrell-model is alleen van toepassing op statische sterkte, niet op dynamisch gedrag',
        'Het voorspelt dat dynamische vervormingsveroudering het materiaal altijd verzacht',
        'Cottrell-atmosferen zijn irrelevant voor moderne legeringen',
      ],
      0,
      'Cottrell-atmosferen (solute-dislocatie-wolken) zetten dislocaties dynamisch vast; concurrentie tussen diffusie-gesteunde ontvergrendeling en hervergrendeling produceert PLC-effect (stroomkarteling).',
    ],
    [
      'In breukmechanica, wat onderscheidt K-gedomineerd (lineaire elastische breukmechanica, LEFM) van J-integraal-gedomineerd (elastisch-plastische breukmechanica, EPFM) regimes, en wanneer is elk van toepassing?',
      [
        'LEFM geldt bij kleine plastische zones, J-integraal bij grote',
        'K en J zijn wiskundig equivalent en geven altijd dezelfde resultaten',
        'J-integraal wordt alleen gebruikt voor keramiek, K voor metalen',
        'LEFM is het enige geldige breukcriterium voor alle materialen',
      ],
      0,
      'LEFM: kleine plastische zone (B, a >> p_y); geldig wanneer σ_Y, elastisch materiaal. EPFM: grote plastische zone; J-integraal legt niet-lineaire pad-onafhankelijkheid vast.',
    ],
    [
      'Welke rol spelen coherentievervormingen in precipitate-versterkingsmechanismen, en hoe verlaagt oververoudering sterkte?',
      [
        'Coherentievervormingen die met deeltjesgrootte verzwakken',
        'Coherentievervormingen bevorderen altijd plastische vervorming',
        'Oververoudering verhoogt hardheid indefinitief',
        'Precipitaatgrootte heeft geen effect op dislocatieverharding',
      ],
      0,
      'Coherente vervormingen maximaliseren snijweerstand; naarmate deeltjes via diffusie grover worden, nemen elastische vervormingen af en neemt Orowan-afstand toe, wat hardheid vermindert.',
    ],
    [
      'In oppervlakte-thermodynamica, wat is de relatie tussen oppervlakte-energie (γ), oppervlakte-overmaat en grensvlak-segregatie, en waarom segregeren bepaalde elementen bij voorkeur?',
      [
        'Zwak gebonden atomen segregeren om grensvlak-energie te verlagen',
        'Oppervlakte-energie is altijd gelijk aan bulkenergie',
        'Segregatie heeft geen thermodynamische drijvende kracht',
        'Alle elementen segregeren met gelijke snelheden ongeacht eigenschappen',
      ],
      0,
      'Segregatie minimaliseert G_interface; elementen met zwakke bulkcohesie en hoge oppervlakte-affiniteit (lage γ, gunstige ΔH_ads) adsorberen bij voorkeur op defecten.',
    ],
    [
      'Wat is de oorsprong van het piëzo-elektrische effect in kristallen, en waarom is het verboden in materialen met inversiesymmetrie?',
      [
        'Ionverplaatsing in niet-centrosymmetrische kristallen',
        'Piëzo-elektriciteit ontstaat alleen uit metallische binding',
        'Inversiesymmetrie vergroot het piëzo-elektrische respons',
        'Het piëzo-elektrische effect is zuiver elektronisch zonder ionverplaatsing',
      ],
      0,
      'Piëzo-elektriciteit: vervormingen breken symmetrie, creëert ongecompenseerde lading. Inversiesymmetrie maakt vervormingen equivalent aan -vervormingen, dus netto dipool = 0.',
    ],
    [
      'In de theorie van martensitische fasetransformaties, wat is de roosterdeformatiegradiënt, en hoe verhoudt Bain-vervormingen zich tot roostercorrespondentie en oriëntatierelatie?',
      [
        'Bain-vervorming plus stijve rotatie van het rooster',
        'Martensitische transformatie is zuiver reconstructief, zonder roostervervormingen',
        'De roostercorrespondentie is willekeurig en niet gerelateerd aan OR',
        'Bain-vervormingen en habitvlak zijn onafhankelijke parameters',
      ],
      0,
      'F = R·U; Bain-vervormingen (rosteruitrekking naar martensiet) + stijve rotatie R bepalen habitvlak (invariant-vlak-vervormingstoestand) en kristal-OR.',
    ],
    [
      'Wat is het mechanisme van scheurbemiddeling in vezelversterkte composieten, en hoe draagt werklengte van vezeltrekking bij aan breuksoepelheid?',
      [
        'Ongebroken vezels over de scheur dissiperen energie',
        'Scheurbemiddeling door vezels vermindert composietstijfheid',
        'Uittrekwerk is altijd verwaarloosbaar in vergelijking met matrixtaaiheid',
        'Vezels moeten breken opdat de composiet bezwijkt',
      ],
      0,
      'Bemiddelde vezels dragen σ_f = τ√(2ρ_f λ) (afschuivertragings); L_eff uittreklengte en grensvlakwrijving τ beheersen Wₚᵤₗₗₒᵤₜ, verhogen rechtstreeks K_IC of G_IC.',
    ],
    [
      'In halfgeleiderbandstructuur-engineering, wat bereikt het concept van \'bandgap-engineering\' via heterojonctie, en welke rol speelt vervormingen?',
      [
        'Vervormde heterostructuren verschuiven bandgaps en offsets',
        'Bandgap-engineering geldt alleen voor elementaire halfgeleiders',
        'Vervormingen verslechteren altijd halfgeleiderprestaties',
        'Bandoffsets worden uitsluitend bepaald door doperingsniveaus',
      ],
      0,
      'Epitactische vervormingen in niet-overeenkomende heterostructuren verschuiven E_g en ΔE_c/ΔEᵥ offsets, stellen op maat afgesnede banduitlijning voor apparaten mogelijk (LED\'s, lasers, thermisch-elektrisch).',
    ],
    [
      'Wat is het Mullins-effect in elastomeren, en welke moleculaire mechanismen beheersen spanningsverzwakking en hysterese in gevulde polymeren?',
      [
        'Afbraak van vulling-polymeer-bindingen en agglomeraten',
        'Het Mullins-effect treedt alleen op in ongevulde elastomeren',
        'Gevulde polymeren vertonen altijd constant spanning-vervormingsgedrag bij herbelasting',
        'Hysterese is zuiver elastisch zonder viskeuze bijdrage',
      ],
      0,
      'Mullins-effect: cyclische belasting breekt vulling-polymeer-interfaces en agglomeraten; lagere modulus bij herbelasting door onomkeerbare structuurveranderingen en viskeuze dissipatie.',
    ],
    [
      'In hoge-temperatuurkruip van keramiek en metalen, wat is de fysische basis van diffusionele kruip (Nabarro-Herring- en Coble-mechanismen), en hoe schalen ze met spanning en korrelgrootte?',
      [
        'Spanningsgedreven leegte-diffusie',
        'Diffusionele kruip is altijd sneller dan dislocatiekruip',
        'Korrelgrootte heeft geen effect op kruipsnelheid',
        'Kruip is zuiver elastische vervorming bij hoge temperatuur',
      ],
      0,
      'N-H (interieur-diffusie) en Coble (korrelgrens-diffusie) schalen met σ en omgekeerde macht van d; snelheden ∝ D(T)σ. Dominant bij lage σ, hoge T.',
    ],
    [
      'Wat is de fysische betekenis van de Debye-temperatuur (Θ_D) in het bepalen van rooster- en warmtetransporteigenschappen, en hoe verhoudt het zich tot mechanische eigenschappen van materialen?',
      [
        'Het schaalt met stijfheid en geluidsnelheid',
        'Debye-temperatuur beïnvloedt alleen optische eigenschappen',
        'Hoge Θ_D betekent altijd betere thermische geleiding',
        'Θ_D is onafhankelijk van elastische eigenschappen',
      ],
      0,
      'Θ_D ≈ ℏω_D/k_B ∝ vₛ; hoge Θ_D geeft stijf rooster aan (hoge E, vₛ). Fononenverstrooiing en gemiddelde vrije weg beheersen κ onafhankelijk.',
    ],
    [
      'In heterogene nucleatie, welke rol spelen contacthoek en oppervlakte-energieverschil in het verminderen van kritieke kerngrootte in vergelijking met homogene nucleatie?',
      [
        'Een lagere contacthoek vermindert de kritieke kerngrootte',
        'Contacthoek beïnvloedt alleen bevochtiging, niet nucleatie',
        'Homogene en heterogene nucleatie hebben identieke kritieke afmetingen',
        'Oppervlakte-energieverschillen zijn altijd verwaarloosbaar voor nucleatie',
      ],
      0,
      'Kritieke straal: r* = 2γₛₗ cosθ/(ρΔg); als θ → 0, r* → min; activeringsenergie ΔG* ∝ f(θ)·γ³/ΔG², wat heterogene paden bevordert.',
    ],
    [
      'Wat is het mechanisme en de betekenis van korrelgroei in nanokristallijne materialen, en waarom is de Zener-speldkracht onvoldoende om nanometerachtige korrels bij verhoogde temperatuur te stabiliseren?',
      [
        'Zener-speldkracht verzwakt naarmate korrels tot nm-schaal krimpen',
        'Nanokristallijne materialen groeien nooit, ongeacht temperatuur',
        'Korrelgroei wordt zuiver beheerst door dislocatiedichtheid, niet door korrelgrenzen',
        'Zener-speld wordt sterker bij kleinere korrelgroottes',
      ],
      0,
      'Korrelgroei: dE/dd ∝ -2γ/d (vermindert G); Zener: F_Z = Z·r/d verzwakt naarmate d krimpt en precipitaatdichtheid daalt; thermische activering overwint zwakke speld.',
    ],
    [
      'In de context van computationele materiaalkunde, wat is dichtheidsfunctionaaltheorie (DFT), en welke benadering (bijv. LDA, GGA) beperkt fundamenteel zijn voorspellende nauwkeurigheid voor grondtoestandeigenschappen?',
      [
        'De uitwisselings-correlatiefunctionaal wordt benaderd',
        'DFT lost direct de volledige Schrödinger-vergelijking zonder benadering op',
        'LDA en GGA zijn exacte functionalen zonder fouten',
        'DFT kan structuureigenschappen niet voorspellen, alleen elektronische',
      ],
      0,
      'DFT-basis: grondtoestands-E uniek bepaald door n(r); Kohn-Sham is exact maar E_xc[n] is onbekend. LDA/GGA benaderen E_xc, introduceren systematische fouten in bandstructuur en barrières.',
    ],
  ],
};
